import {
    Pipe, PipeTransform
} from "@angular/core";
import {
    Language, EnumUtil
} from "@shopliftr/common-js/data";

/**
 * Returns a display value for a Language
 *
 * Handles an array by joining them with the provided array separator or by with commas
 */
@Pipe({ name: "mgdLanguage" })
export class LanguagePipe implements PipeTransform {

    transform(value: Language | Array<Language>, arraySeparator?: string): string {

        if (!value) {
            return "";
        }

        if (Array.isArray(value)) {
            return value.map((item) => this.transform(item)).join(arraySeparator ?? ", ");
        }
        return EnumUtil.getDisplayValue(value, Language) ?? "Unknown";
    }
}
